// https://www.figma.com/file/r31Oyqfbdu8jfSSyxd6ze5/Air-Fryer-Component-Library?node-id=2514%3A279584#176159731
export var noneEntered = 'None entered';
export var notApplicable = 'Not applicable';
export var none = 'None';
export var notAvailable = 'Not available';
export var telehealth = 'Telehealth';
export var inPerson = 'In Person';
export var defaultSpringCrisisLine = '+1 (855) 629-0554 opt. 2';
export var employeeSpringCrisisLine = '866-212-6049 or 877-565-3222 (option 1)';
export var GENERIC_ERROR_TITLE = 'Something went wrong.';
export var GENERIC_ERROR_MESSAGE = 'Please try again, and contact support if this error persists.';
export var MAIL_SUPPORT = 'mailto:providerops@springhealth.com';
export var BUTTON_SUPPORT = 'Contact Support';
